module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="js-control-term u-spaceBottom"></div>\n<div class="js-control-categories u-spaceBottom"></div>\n<div class="u-textRight">\n    <a class="js-reset-search-form js-toggle-page link-buttonAligned u-spaceRight is-hidden"\n        href="javascript:void(0);" data-page="overview">Reset all</a>\n    <button class="js-control-submit btn btn-inline">\n        <i class="icon icon-spaceRight icon-search-white" title="Search"></i>Search\n    </button>\n</div>\n';
}
return __p;
};
